import { SET_CONFIRMATION_MODAL, SET_LOADING, TOGGLE_TAB_BAR } from '@actions/types'

const initialState = {
  confirmationModal: null,
  isLoading: [],
  hideTabBar: false
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
  case SET_CONFIRMATION_MODAL:
    return {
      ...state,
      confirmationModal: payload
    }
  case SET_LOADING:
    return {
      ...state,
      isLoading: payload
    }
  case TOGGLE_TAB_BAR:
    return {
      ...state,
      hideTabBar: !state.hideTabBar
    }
  default:
    return state
  }
}

export default reducer
